import { z } from '@campai/lib-common/utils/zod'
import { type RouterInput } from '@campai/lib-web/utils/trpc'

import { TAG_FILTER_ALL } from '@/product/feedback/tagFilter'
import { STATUS_OPTIONS } from '@/product/feedback/status'

type TicketSort = RouterInput['product']['feedback']['listTickets']['sort']

export const statusFilterOptions = ['all', ...STATUS_OPTIONS] as const
export const ticketSortOptions = ['latestActivity', 'newest', 'oldest', 'mostVotes', 'mostComments'] as const

export type StatusFilterOption = (typeof statusFilterOptions)[number]
export type TicketSortOption = (typeof ticketSortOptions)[number]

export const SearchSchema = z.object({
    page: z.number().int().positive().optional().default(1),
    searchTerm: z.string().optional(),
    status: z.enum(statusFilterOptions).optional().default('all'),
    sort: z.enum(ticketSortOptions).optional().default('latestActivity'),
    tag: z.string().optional().default(TAG_FILTER_ALL),
})

export type Search = z.infer<typeof SearchSchema>

export const pageSize = 30

export const isStatusFilterOption = (value: unknown): value is StatusFilterOption => {
    return statusFilterOptions.some((statusOption) => statusOption === value)
}

export const isTicketSortOption = (value: unknown): value is TicketSortOption => {
    return ticketSortOptions.some((sortOption) => sortOption === value)
}

export const getTicketSort = (sortOption: TicketSortOption): TicketSort => {
    switch (sortOption) {
        case 'newest':
            return { createdAt: 'desc' }
        case 'oldest':
            return { createdAt: 'asc' }
        case 'mostVotes':
            return { votesCount: 'desc', latestActivityAt: 'desc' }
        case 'mostComments':
            return { commentsCount: 'desc', latestActivityAt: 'desc' }
        case 'latestActivity':
            return { latestActivityAt: 'desc', createdAt: 'desc' }
    }
}
